import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useVacancyApi } from "../../apis/vacancy-api";
import VacancyEditWizard, {
  VacancyFormFields,
} from "../vacancy/VacancyCreateWizard";
import useAuthData from "../../auth/useAuthData";
import { VacancyLesson } from "../../models/schedule/lesson";
import FullScreenContainer from "../../components/FullScreenContainer";

function VacancyUpdate() {
  const { id } = useParams();
  const { getVacancy, updateVacancyWithLessons } = useVacancyApi();
  const { currentSchool: school } = useAuthData();
  const navigate = useNavigate();

  if (!id) {
    throw Error("No vacancy id provided");
  }

  const { data: vacancy } = useQuery(["vacancy", id], () => getVacancy(id));

  const onUpdateVacancy = async (formValues: VacancyFormFields) => {
    if (!vacancy || !school) return;
    await updateVacancyWithLessons(vacancy.id, school.id, vacancy.lessons, {
      ...formValues,
      vacancyId: vacancy.id,
      absentTeacherEmail: formValues.teacher.id,
      lessons: formValues.lessons.map((l) =>
        VacancyLesson.toCreateVacancyLesson(l),
      ),
      start: new Date(formValues.start),
      end: new Date(formValues.end),
    });

    navigate(-1);
  };

  return (
    <FullScreenContainer className="flex bg-nid_grey p-4 md:p-8">
      {vacancy && school && (
        <VacancyEditWizard
          vacancy={vacancy}
          school={school}
          onSubmit={onUpdateVacancy}
        ></VacancyEditWizard>
      )}
    </FullScreenContainer>
  );
}

export default VacancyUpdate;
